import React from 'react'

function UnderMaintenance() {
  return (
    <div className='flex h-screen w-screen items-center justify-center px-4 md:px-16'>
      <div>
        <h1 className='font-bold text-3xl md:text-5xl text-tBlack mb-4 text-center'>Website is under maintenance</h1>
        <p className='text-gray-500 max-w-lg text-center mx-auto'>
          We're currently performing some scheduled maintenance. We’ll be back online shortly, thank you for your
          patience. If you have any questions, feel free to contact us at <br />
          <a className='underline hover:text-tGreen transition-colors' href='mailto:support@trybe.do'>
            support@trybe.do
          </a>
        </p>
      </div>
    </div>
  )
}

export default UnderMaintenance
